<template>
  <div class="m-35">
    <div class="ml-20 color-black">
      发布商品
      <router-link to="/product" class="ml-10">返回</router-link>
    </div>
    <div class="container p-30 mt-35">
      <el-alert
        title="请选择正确的类目发布商品，否则平台有权下架或者屏蔽您的商品。"
        type="warning"
        :closable="false"
        show-icon
      ></el-alert>
      <el-cascader
        class="mt-30"
        style="width: 360px;"
        placeholder="搜索类目"
        :options="categories"
        clearable
        filterable
        v-model="searchCategory"
        :props="{
          value: 'id',
          label: 'name',
          children: 'sub_cat'
        }"
        ></el-cascader>
      <!-- 级联选择 -->
      <el-cascader-panel
        v-if="displayCascader"
        v-loading="loadingCate"
        class="mt-30"
        :options="categories"
        v-model="category"
        :props="{
          value: 'id',
          label: 'name',
          children: 'sub_cat'
        }"></el-cascader-panel>

      <el-alert
        v-if="!!categoryId"
        class="mt-30"
        :title="'已选类目：' + selectedCategory"
        type="success"
        :closable="false"
      ></el-alert>

      <div class="mt-30 flex-center-center">
        <el-button
          type="primary"
          :disabled="!categoryId"
          round
          @click="handlePost"
        >确认，下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// ------------------------------------------------------
// 此页面为独立选择分类页，及分类选择独立出来，先选分类再发布产品。
// 方式类似淘宝等平台。
// 可以暂时不删除。需要的时候启用即可。
// date：2020-08-18
// ------------------------------------------------------
import { getCategories } from '@/api/product.js';
export default {
  data() {
    return {
      loadingCate: false, // 是否显示分类加载动画
      displayCascader: true, // 是否渲染分类级联面板，用于更新后强制渲染使用
      categories: [], // 分类列表
      searchCategory: [], // 搜索选中的ID组
      category: [0, 0, 0], // 选中的分类ID组
      categoryId: 0, // 选中的分类ID
      selectedCategory: null // 展示选中的分类名称
    };
  },
  created() {
    // 获取所有的分类信息
    this.loadCategories();
  },
  watch: {
    // 监听搜索分类
    // 搜索成立时，修改选中的分类，并清空
    searchCategory(v) {
      if (v.length === 3) {
        this.category = v;
        // 清空搜索项
        this.searchCategory = [];

        // 移除分类级联面板，待渲染完成后重新渲染
        this.displayCascader = false;
        this.$nextTick(() => {
          this.displayCascader = true;
        });

        // 重组选中分类字符串
        this.rebuildSelectedName();
      }
    },
    // 监听分类改变
    // 设置选中的分类ID，重组选中的分类字符串
    category(v) {
      if (v.length === 3) {
        this.categoryId = v[2];
        this.rebuildSelectedName();
      }
    }
  },
  methods: {
     // 获取所有的分类信息
    async loadCategories() {
      this.loadingCate = true;
      const results = await getCategories();
      this.loadingCate = false;
      this.categories = results;
    },
    // 进入信息发布页
    handlePost() {
      this.$router.push({
        path: `/product/post`,
        query: { category_id: this.categoryId, category_name: this.selectedCategory }
      })
    },
    // 生成选中的分类字符串
    rebuildSelectedName() {
      if (this.category.length !== 3) {
        this.selectedCategory = null;
      } else {
        this.selectedCategory = this.searchName(0, this.categories);
      }
    },
    // 从分类中搜索选中的分类名称
    searchName(index, item) {
      if (!this.category[index]) return null;
      let _str = '';
      item.forEach(v1 => {
        if (v1.id === this.category[index]) {
          _str += v1.name;
          if (v1.sub_cat) {
            let subStr = this.searchName(index+1, v1.sub_cat);
            if (subStr) _str += ' / ' + subStr;
          }
        }
      })
      return _str;
    }
  }
}
</script>

<style lang="sass" scoped>
</style>